import React, { type PropsWithChildren } from "react";

import { Table } from "@devexpress/dx-react-grid-bootstrap4";

export const TableRow = (props: PropsWithChildren<Table.DataRowProps>) => (
  <Table.Row
    {...props}
    className={props.row.index % 2 === 0 ? "even" : "odd"}
  />
);
